'use client'

import React from 'react'
import { cn } from '@workspace/ui/lib/utils'
import { Button } from '@workspace/ui/components/Button'

export interface SearchCategory {
    id: string
    label: string
    count: number
}

interface SearchCategoryTabsProps {
    categories: SearchCategory[]
    selectedCategory: string | null
    onSelect: (id: string | null) => void
    className?: string
    isHidden?: boolean
}

export function SearchCategoryTabs({
    categories,
    selectedCategory,
    onSelect,
    className,
    isHidden = false,
}: SearchCategoryTabsProps) {
    if (isHidden) return null
    return (
        <div className={cn('flex items-center gap-2 flex-wrap', className)}>
            {categories.map(category => (
                <Button
                    key={category.id}
                    onClick={() => onSelect(selectedCategory === category.id ? null : category.id)}
                    size={'sm'}
                    className={cn(
                        'flex items-center px-2 py-0.5 text-foreground bg-gray-900/10 rounded-full text-xs font-medium shadow-none',
                        selectedCategory === category.id && 'bg-primary text-text-accent',
                    )}
                >
                    {`${category.label} (${category.count})`}
                </Button>
            ))}
        </div>
    )
}
